/**
 * 退回修改（EditErrorInfo）挂载表单时传入。
 * - 旧：函数调用 component('re_edit')，props 为字符串
 * - 新：JSX <Comp reEdit />，props.reEdit === true
 */
export const isOpenProgressReEdit = (props: unknown): boolean => {
  if (props === 're_edit') return true;
  if (props && typeof props === 'object' && (props as { reEdit?: boolean }).reEdit) return true;
  return false;
};
